import React from 'react';
import styled from 'styled-components';
import { Icon, IconProps } from '../icon';
import { PropertiesPanelControl, PropertiesPanelLabel, PropertiesPanelProperty } from './propertiesPanelProperty';

export type PropertiesPanelIconPropertyProps = {
    id: string;
    label: React.ReactNode;
    icon: React.ReactNode;
    onIconClick?: IconProps['onClick'];
    disabled?: boolean;
};

const CompactIcon = styled(Icon)`
    width: 18px;
    height: 18px;
`;

export const PropertiesPanelIconProperty: React.FC<PropertiesPanelIconPropertyProps> = ({ id, label, icon, onIconClick, disabled }) => {
    return (
        <PropertiesPanelProperty>
            <PropertiesPanelLabel htmlFor={`${id}-input`}>{label}</PropertiesPanelLabel>
            <PropertiesPanelControl>
                <CompactIcon onClick={onIconClick} disabled={disabled} $hoverable>
                    {icon}
                </CompactIcon>
            </PropertiesPanelControl>
        </PropertiesPanelProperty>
    );
};
